import { ref, watch, onActivated } from 'vue'
import { getBriefReport } from '@/api/gucangSales/index'
import { BriefReportParams, BackKeyData } from '@/typings/api/index'

export default function keyBackDataMethod(params:BriefReportParams) {
  const keyBackData = ref<BackKeyData>({
    chanceCount: 0,
    customerCount: 0,
    followCount: 0,
    planSaleAmount: 0,
    visitCount: 0
  })

  const getData = async() => {
    try {
      const res = await getBriefReport(params)
      if (res.data) {
        keyBackData.value = res.data
      } else {
        keyBackData.value = {
          chanceCount: 0,
          customerCount: 0,
          followCount: 0,
          planSaleAmount: 0,
          visitCount: 0
        }
      }
    } catch (error) {
      console.log('keyBackData error: ', error)
    }
  }
  watch(params, () => {
    getData()
  }, {
    immediate: true
  })
  onActivated(() => {
    getData()
  })
  return { keyBackData }
}
